module.exports = __webpack_public_path__ + "static/img/wechat_code.19ecc27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechat_code.png
// module id = noiM
// module chunks = 39